import type { Types as OData } from 'shared/odata'
import { mailboxHooks } from 'features/messaging'
import { generateCorrelationId } from 'api/utils/requestHeaders'

import { api } from '../api'

export function useChatContact() {
	const participant = mailboxHooks.useConversationalist()
	const id = participant?.entityId ?? ''

	return api.useContactByLinkedInIdQuery(id, {
		skip: !id
	})
}

export function useSendToTeamMember() {
	const [send, { isLoading, error }] = api.useSendToTeamMemberMutation()

	return [
		async (
			filters: Partial<OData.AudienceParams>,
			targetPersonaId: string
		) => {
			const { $filter, $orderby, $searchQuery } = filters
			const correlationId = generateCorrelationId()

			return await send({
				personaId: targetPersonaId,
				correlationId,
				$filter,
				$orderby,
				$searchQuery
			}).unwrap()
		},
		{ isLoading, error }
	] as const
}